import { GlobalStyles } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import DrawControl from '../../../map/DrawControl';
import { selectClearMapDrawFeatures } from '../../onboardingSlice';

interface Props {
  onboardingTabIndex?: number;
}

const MapDrawControls: React.FC<Props> = ({ onboardingTabIndex }) => {
  const clearMapDrawFeatures = useAppSelector(selectClearMapDrawFeatures);

  return (
    <>
      {/* 
    This control can be affected only by global styles overrides
    image - is b64 svg in background-image so only way to change its color
    is to use filter for color inversion.
    There is no sense to add wrappers for this control because it's will be mounted
    internally by mapbox. 
    */}

      <GlobalStyles
        styles={(theme) => ({
          '.mapboxgl-ctrl-group': {
            backgroundColor: theme.colors.darkTheme.grey.medium,
          },
          '.mapboxgl-ctrl-group > button': {
            filter: 'invert(100%)',
          },
        })}
      />
      <DrawControl
        key={
          onboardingTabIndex === undefined
            ? clearMapDrawFeatures
            : onboardingTabIndex + clearMapDrawFeatures
        } // This is a hack to force the DrawControl to re-render when the clearMapDrawFeatures or onboarding tab changes which will clear the currently drawn features and set the correct available drawing tools.  It just updates the key to a random new unique value to force the re-render.
        displayControlsDefault={false}
        controls={{
          line_string:
            onboardingTabIndex !== undefined
              ? onboardingTabIndex === 0
                ? false
                : true
              : true,
          polygon:
            onboardingTabIndex !== undefined
              ? onboardingTabIndex === 0
                ? true
                : false
              : true,
          trash: true,
        }}
      />
    </>
  );
};

export default MapDrawControls;
